jQuery(document).ready(function ($) {

    /*$('.gallery').lightGallery({
        selector: '.gallery__item'
    });*/

    $('.site-header__hamburger-cta').click(function () {
        $(this).toggleClass('is-active');
        $('.site-header__nav-wrapper').toggleClass('site-header__nav-wrapper--active');
        $('body').toggleClass('nav-active');
    });


	if(jQuery(window).width() < 1024) {
		jQuery('.menu-item-has-children > a').click(function(e) {
            e.preventDefault();
			var link = jQuery(this);
			if (link.parent().hasClass('menu-item-has-children--active')) {
                link.parent().removeClass('menu-item-has-children--active');
				return true;
			} else {
				jQuery('.menu-item-has-children').not(this).removeClass('menu-item-has-children--active');
				link.parent().addClass('menu-item-has-children--active');
				//e.preventDefault();
				return false; 
			}
		});
	}


    $('.products-item .btn').click(function(e){
        e.preventDefault();
        $('#products-item-id-'+$(this).attr('href')).fadeIn(500);
        $('body').addClass('lightbox-active');
    });

    $('.products-item__details-close').click(function(e){
        $(this).parents('.products-item__overlay').fadeOut(500,function(){
            $('body').removeClass('lightbox-active')
        });
    }); 

    $('.quotes').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: true,
        autoplay:true,
        autoplayTimeout:10000,
        items: 1,
        //navText: ['<i class="fas fa-angle-left"></i>','<i class="fas fa-angle-right"></i>']
        navText: ['<span class="quote-arrow quotes__prev"></span>','<span class="quote-arrow quotes__next"></span>']
    });
    
    $('.picturetext-full-slider').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: true,
        autoplay:true,
        autoplayTimeout:20000,
        items: 1,
        //navText: ['<i class="fas fa-angle-left"></i>','<i class="fas fa-angle-right"></i>']
        navText: ['<span class="quote-arrow quotes__prev"></span>','<span class="quote-arrow quotes__next"></span>']
    });


    window.onscroll = function() {stickyHeader()};
    var header = document.getElementById("site-header");
    var sticky = header.offsetTop + 50;
    function stickyHeader() {
        if (window.pageYOffset > sticky) {
            header.classList.add("site-header--sticky");
            //$('.site-header__breadcrumb').css('background','blue');
        } else {
            header.classList.remove("site-header--sticky");
            //$('.site-header__breadcrumb').css('background','red');
        }
    }
    
    
    $( ".block-accordion__titel" ).click(function(event) {
        $(this).parent('div').toggleClass('block-accordion__item--open');
    });    


    $( ".block-tabs__titel" ).click(function(event) {
        var $tabindex = $(this).parent('div').index();
		console.log($tabindex);

        var $tabs = $(this).parent('div').parent('div').children('.block-tabs__column').children('div');
        var $contents = $(this).parent('div').parent('div').parent('div').children('.block-tabs__contents').children('div');

        $( $tabs ).removeClass('block-tabs__titel--active');
        $( $tabs ).addClass('block-tabs__titel--inactive');
        $( $contents ).removeClass('block-tabs__text--active');
        $( $contents ).addClass('block-tabs__text--inactive');

        $( $(this) ).removeClass('block-tabs__titel--inactive');
        $( $(this) ).addClass('block-tabs__titel--active');
        $( $contents.get( $tabindex ) ).removeClass('block-tabs__text--inactive');
        $( $contents.get( $tabindex ) ).addClass('block-tabs__text--active');
    
    });
    
    $( ".block-pyramidswitch__picture" ).click(function(event) {
        var $tabindex = $(this).index();
		console.log($tabindex);

        var $tabs = $(this).parent('div').parent('div').children('.block-pyramidswitch__tabs').children('div');
        var $contents = $(this).parent('div').parent('div').children('.block-pyramidswitch__content').children('div');

        $( $tabs ).removeClass('block-pyramidswitch__picture--active');
        $( $tabs ).addClass('block-pyramidswitch__picture--inactive');
        $( $contents ).removeClass('block-pyramidswitch__text--active');
        $( $contents ).addClass('block-pyramidswitch__text--inactive');

        $( $(this) ).removeClass('block-pyramidswitch__picture--inactive');
        $( $(this) ).addClass('block-pyramidswitch__picture--active');
        $( $contents.get( $tabindex ) ).removeClass('block-pyramidswitch__text--inactive');
        $( $contents.get( $tabindex ) ).addClass('block-pyramidswitch__text--active');
            
    });
    
    //const ScrollReveal = require('scrollreveal');
//new Vivus('svg-animation', {duration: 150},vivusCallback);
    //$('#svg-animation').css('opacity','1');


    var svgElement = document.getElementById("svg-animation");
    if(typeof(svgElement) != 'undefined' && svgElement != null){
        $('#svg-animation').animate({opacity: 1}, 100);
        new Vivus('svg-animation', {duration: 100, start: "autostart"}, function (obj) {
            obj.el.classList.add('finished');
        });
    }


    wow1 = new WOW(
        {
            boxClass:     'main-content > *:not(.block-header-wrapper)',      // default
            animateClass: 'animated', // default
            offset:       0,          // default
            mobile:       true,       // default
            live:         true        // default
        }
    )
    wow1.init();

    wow2 = new WOW(
        {
            boxClass:     'wow',      // default
            animateClass: 'animated', // default
            offset:       0,          // default
            mobile:       true,       // default
            live:         true        // default
        }
    )
    wow2.init();



    var a = 0;
    if ($('.facts-and-figures').length > 0) {
        $(window).scroll(function() {
          var oTop = $('.facts-and-figures').offset().top - window.innerHeight;
          if (a == 0 && $(window).scrollTop() > oTop) {
            $('.counter-value').each(function() {
              var $this = $(this),
                countTo = $this.attr('data-count');
                
              $({
                countNum: $this.find('span')
              }).animate({
                  countNum: countTo
                },
        
                {
                  duration: 4000,
                  easing: 'swing',
                  step: function() {
                    $this.find('span').text(Math.floor(this.countNum));
                    
                  },
                  complete: function() {
                    $this.find('span').text(this.countNum);
                  }
        
                });
            });
            a = 1;
          }
        });
    }

});